// working maintenance


import React, { useEffect, useRef, useState } from 'react';
import { getAdminActions } from '../../../config/actions';
import Top from '../Top';
import QuickActionsSidebar from '../DistributorDashboard/QuickActionsSidebar';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';
import "./SoftwareUpdate.css";




const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));
const SoftwareUpdate = ()=>{
    const navigate = useNavigate();
    const [purchaseModal, setPurchaseModal] = useState(false);
    const [expandedMenu, setExpandedMenu] = useState(null);

    const classes = useStyles();
    const handleNewUpdate = () =>{
      navigate('/new-software')
    }
    const handleEditUpdate = ()=>{
        navigate('/edit-software')
    }
  const NewSoftwareAnnouncement = () =>{
    navigate('/new-software-announcement')
  }
  const EditSoftwareAnnouncement = () =>{
    navigate('/edit-software-announcement')
  }

  const uid = localStorage.getItem("uid");
  const adminActions = getAdminActions(uid);

    return(
        <div className="software-update-container">
            <div className="software-update-dashboard">
                <QuickActionsSidebar actions={adminActions} expandedMenu={expandedMenu} setExpandedMenu={setExpandedMenu} />
                <div className="software-update-content">
                    <div className="add-btn-wrp add-btn-wrp2">
                        <div className='button-div'>
                        <button className='create-button' onClick={handleNewUpdate}>New Software Update</button>
                        <button className='create-button' onClick={handleEditUpdate} >Edit Software Update</button>
                        {/* <button className='create-button' onClick={NewSoftwareAnnouncement} >New Software Announcements</button>
                        <button className='create-button' onClick={EditSoftwareAnnouncement}>Edit Software Announcements</button> */}
                        </div>    
                    </div>
                </div>
            </div>
          

        </div>
    )
}
export default SoftwareUpdate;